export default  {
    path: 'product_specimen/list',
    name: 'product_specimen',
    component: () => import('@/pages/product_specimen/ProductSpecimenList'),
    meta: { title: '寄样管理' },
}
